import * as Yup from 'yup';

import { REFERRAL_FORM_TEXT_MIN_LENGTH } from './constants';

export const REFERRAL_FORM_SCHEMA = Yup.object({
  referral_physician_name: Yup.string()
    .min(
      REFERRAL_FORM_TEXT_MIN_LENGTH,
      `Referral physician name must be at least ${REFERRAL_FORM_TEXT_MIN_LENGTH} characters`,
    )
    .required('Referral physician name is required'),
  diagnosis_date: Yup.mixed().required('Diagnosis date is required'),
  diagnosis_city: Yup.string()
    .min(
      REFERRAL_FORM_TEXT_MIN_LENGTH,
      `Diagnosis city must be at least ${REFERRAL_FORM_TEXT_MIN_LENGTH} characters`,
    )
    .required('Diagnosis city is required'),
  diagnosis_state: Yup.string().required('Diagnosis state is required'),
  diagnostic_assessments_used: Yup.array()
    .of(Yup.string().required())
    .min(1, 'At least one assessment is required')
    .default([]),
  diagnoses: Yup.array()
    .of(Yup.string().required())
    .min(1, 'At least one diagnosis is required')
    .default([]),
});
